/**
 * Mobile menu accordion — The Row style
 * Moves sub-panel content inline below each parent button
 * so items expand downward in the same panel (not slide sideways)
 */
(function () {
  function initAccordion() {
    if (window.innerWidth > 989) return;

    const navElements = document.querySelectorAll('.slide-out-menu');
    if (!navElements.length) return;

    navElements.forEach(function (nav) {
      const primaryPanel = nav.querySelector('.primary-menu-panel');
      if (!primaryPanel) return;

      // Already processed
      if (primaryPanel.dataset.accordionInit) return;
      primaryPanel.dataset.accordionInit = '1';

      const topListItems = primaryPanel.querySelectorAll(':scope > ul > li');

      topListItems.forEach(function (li) {
        const btn = li.querySelector(':scope > button.menu-link[data-ref]');
        if (!btn) return;

        const ref = btn.getAttribute('data-ref');
        const sourcePanel = nav.querySelector('.menu-panel[data-menu="' + ref + '"]');
        if (!sourcePanel) return;

        // Get the sub-panel's <ul>
        const subUl = sourcePanel.querySelector('ul');
        if (!subUl) return;

        // Create accordion wrapper and inject it into the <li>
        const accordion = document.createElement('div');
        accordion.className = 'varea-accordion';

        // Clone each child link/button into the accordion
        const clonedUl = subUl.cloneNode(true);

        // Handle nested sub-sub-panels inside cloned list
        clonedUl.querySelectorAll('button.menu-link[data-ref]').forEach(function (nestedBtn) {
          const nestedRef = nestedBtn.getAttribute('data-ref');
          const nestedPanel = nav.querySelector('.menu-panel[data-menu="' + nestedRef + '"]');
          if (!nestedPanel) return;

          const nestedUl = nestedPanel.querySelector('ul');
          if (!nestedUl) return;

          const nestedAccordion = document.createElement('div');
          nestedAccordion.className = 'varea-accordion varea-accordion--nested';
          nestedAccordion.appendChild(nestedUl.cloneNode(true));

          const nestedLi = nestedBtn.closest('li');
          if (nestedLi) {
            nestedLi.appendChild(nestedAccordion);

            const freshNested = nestedBtn.cloneNode(true);
            nestedBtn.parentNode.replaceChild(freshNested, nestedBtn);

            freshNested.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              const open = freshNested.classList.contains('is-open');
              // Close siblings
              clonedUl.querySelectorAll('button.menu-link.is-open').forEach(b => b.classList.remove('is-open'));
              clonedUl.querySelectorAll('.varea-accordion--nested.is-open').forEach(a => a.classList.remove('is-open'));
              if (!open) {
                freshNested.classList.add('is-open');
                nestedAccordion.classList.add('is-open');
              }
            });
          }
        });

        accordion.appendChild(clonedUl);
        li.appendChild(accordion);

        // Hide original panel (no longer needed)
        sourcePanel.setAttribute('aria-hidden', 'true');
        sourcePanel.style.cssText = 'display:none!important';

        // Replace button to remove theme's click handler
        const freshBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(freshBtn, btn);

        freshBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const isOpen = freshBtn.classList.contains('is-open');

          // Close all top-level accordions
          primaryPanel.querySelectorAll('button.menu-link.is-open').forEach(b => b.classList.remove('is-open'));
          primaryPanel.querySelectorAll('.varea-accordion:not(.varea-accordion--nested).is-open').forEach(a => a.classList.remove('is-open'));

          if (!isOpen) {
            freshBtn.classList.add('is-open');
            accordion.classList.add('is-open');
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initAccordion);
  document.addEventListener('shopify:section:load', function () {
    // Re-init: reset flag so it runs again
    document.querySelectorAll('[data-accordion-init]').forEach(function (el) {
      delete el.dataset.accordionInit;
    });
    initAccordion();
  });
})();
